// extracted by mini-css-extract-plugin
export default {"block":"Timer_block__5ny8c","dial":"Timer_dial__DD6xO","last_dial":"Timer_last_dial__RnTiA"};